// ------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template.
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
// ------------------------------------------------------------------------------

import { Dictionary } from '../../../shared/models/dictionary.model';
import { IBaseType } from '../../../shared/enums/ibase-type.enum';

export interface IFuelType {
    id: number;
    value: string;
    displayValue: string;
    description: string;
    isAlternative: boolean;
    sortOrder: number;
    active: boolean;
    nMVTISFuelTypeCode: string;
    nMVTISFuelTypeDisplayValue: string;
}

export class FuelType implements IFuelType, IBaseType {
    public id: number;
    public value: string;
    public displayValue: string;
    public description: string;
    public isAlternative: boolean;
    public sortOrder: number;
    public active: boolean;
    public nMVTISFuelTypeCode: string;
    public nMVTISFuelTypeDisplayValue: string;

    /**
		Returns Alcohol-pre98 FuelType
	**/
    get A(): IFuelType {
        return this.FromId(1);
    }
    /**
		Returns Compressed Natural Gas FuelType
	**/
    get C(): IFuelType {
        return this.FromId(2);
    }
    /**
		Returns Diesel FuelType
	**/
    get D(): IFuelType {
        return this.FromId(3);
    }
    /**
		Returns Electric non-compliant FuelType
	**/
    get E(): IFuelType {
        return this.FromId(4);
    }
    /**
		Returns Gasoline FuelType
	**/
    get G(): IFuelType {
        return this.FromId(5);
    }
    /**
		Returns Hybrid FuelType
	**/
    get H(): IFuelType {
        return this.FromId(6);
    }
    /**
		Returns Kerosene FuelType
	**/
    get K(): IFuelType {
        return this.FromId(7);
    }
    /**
		Returns Liquefied Petroleum Gas (Butane or Propane) FuelType
	**/
    get L(): IFuelType {
        return this.FromId(8);
    }
    /**
		Returns Liquefied Natural Gas FuelType
	**/
    get N(): IFuelType {
        return this.FromId(9);
    }
    /**
		Returns Other FuelType
	**/
    get O(): IFuelType {
        return this.FromId(10);
    }
    /**
		Returns Solar FuelType
	**/
    get S(): IFuelType {
        return this.FromId(11);
    }
    /**
		Returns Steam FuelType
	**/
    get T(): IFuelType {
        return this.FromId(12);
    }
    /**
		Returns Hydrocarbon FuelType
	**/
    get W(): IFuelType {
        return this.FromId(13);
    }
    /**
		Returns Alcohol-post98 FuelType
	**/
    get Z(): IFuelType {
        return this.FromId(14);
    }
    /**
		Returns None FuelType
	**/
    get U(): IFuelType {
        return this.FromId(15);
    }
    /**
		Returns Hydrogen Fuel Cell FuelType
	**/
    get R(): IFuelType {
        return this.FromId(26);
    }
    /**
		Returns Electric FuelType
	**/
    get X(): IFuelType {
        return this.FromId(27);
    }

    private _dictionary: Dictionary = new Dictionary([]);

    constructor() {
        this._dictionary.add('1', { id: 1, value: 'A', displayValue: 'Alcohol-pre98', description: 'Alcohol-pre98', isAlternative: true, sortOrder: 999999, active: false, nMVTISFuelTypeCode: 'O', nMVTISFuelTypeDisplayValue: 'Other' });
        this._dictionary.add('2', { id: 2, value: 'C', displayValue: 'Compressed Natural Gas', description: 'Compressed Natural Gas', isAlternative: true, sortOrder: 999999, active: true, nMVTISFuelTypeCode: 'C', nMVTISFuelTypeDisplayValue: 'Compressed Natural Gas' });
        this._dictionary.add('3', { id: 3, value: 'D', displayValue: 'Diesel', description: 'Diesel', isAlternative: false, sortOrder: 999999, active: true, nMVTISFuelTypeCode: 'D', nMVTISFuelTypeDisplayValue: 'Diesel' });
        this._dictionary.add('4', { id: 4, value: 'E', displayValue: 'Electric non-compliant', description: 'Electric non-compliant', isAlternative: true, sortOrder: 999999, active: true, nMVTISFuelTypeCode: 'E', nMVTISFuelTypeDisplayValue: 'Electric' });
        this._dictionary.add('5', { id: 5, value: 'G', displayValue: 'Gasoline', description: 'Gasoline', isAlternative: false, sortOrder: 999999, active: true, nMVTISFuelTypeCode: 'G', nMVTISFuelTypeDisplayValue: 'Gasoline' });
        this._dictionary.add('6', { id: 6, value: 'H', displayValue: 'Hybrid', description: 'Hybrid', isAlternative: false, sortOrder: 999999, active: true, nMVTISFuelTypeCode: 'H', nMVTISFuelTypeDisplayValue: 'Hybrid' });
        this._dictionary.add('7', { id: 7, value: 'K', displayValue: 'Kerosene', description: 'Kerosene', isAlternative: false, sortOrder: 999999, active: false, nMVTISFuelTypeCode: 'K', nMVTISFuelTypeDisplayValue: 'Kerosene' });
        this._dictionary.add('8', { id: 8, value: 'L', displayValue: 'Liquefied Petroleum Gas (Butane or Propane)', description: 'Liquefied Petroleum Gas (Butane or Propane)', isAlternative: true, sortOrder: 999999, active: true, nMVTISFuelTypeCode: 'L', nMVTISFuelTypeDisplayValue: 'Liquefied Petroleum Gas (Butane & Propane)' });
        this._dictionary.add('9', { id: 9, value: 'N', displayValue: 'Liquefied Natural Gas', description: 'Liquefied Natural Gas', isAlternative: true, sortOrder: 999999, active: false, nMVTISFuelTypeCode: 'N', nMVTISFuelTypeDisplayValue: 'Liquefied Natural Gas' });
        this._dictionary.add('10', { id: 10, value: 'O', displayValue: 'Other', description: 'Other', isAlternative: false, sortOrder: 999999, active: false, nMVTISFuelTypeCode: 'O', nMVTISFuelTypeDisplayValue: 'Other' });
        this._dictionary.add('11', { id: 11, value: 'S', displayValue: 'Solar', description: 'Solar', isAlternative: true, sortOrder: 999999, active: false, nMVTISFuelTypeCode: 'O', nMVTISFuelTypeDisplayValue: 'Other' });
        this._dictionary.add('12', { id: 12, value: 'T', displayValue: 'Steam', description: 'Steam', isAlternative: false, sortOrder: 999999, active: false, nMVTISFuelTypeCode: 'S', nMVTISFuelTypeDisplayValue: 'Steam' });
        this._dictionary.add('13', { id: 13, value: 'W', displayValue: 'Hydrocarbon', description: 'Hydrocarbon', isAlternative: false, sortOrder: 999999, active: false, nMVTISFuelTypeCode: 'O', nMVTISFuelTypeDisplayValue: 'Other' });
        this._dictionary.add('14', { id: 14, value: 'Z', displayValue: 'Alcohol-post98', description: 'Alcohol-post98', isAlternative: false, sortOrder: 999999, active: false, nMVTISFuelTypeCode: 'O', nMVTISFuelTypeDisplayValue: 'Other' });
        this._dictionary.add('15', { id: 15, value: 'U', displayValue: 'None', description: 'None', isAlternative: false, sortOrder: 999999, active: true, nMVTISFuelTypeCode: 'O', nMVTISFuelTypeDisplayValue: 'Other' });
        this._dictionary.add('26', { id: 26, value: 'R', displayValue: 'Hydrogen Fuel Cell', description: 'Hydrogen Fuel Cell', isAlternative: true, sortOrder: 999999, active: false, nMVTISFuelTypeCode: '', nMVTISFuelTypeDisplayValue: 'Other' });
        this._dictionary.add('27', { id: 27, value: 'X', displayValue: 'Electric', description: 'Electric', isAlternative: true, sortOrder: 999999, active: true, nMVTISFuelTypeCode: 'E', nMVTISFuelTypeDisplayValue: 'Electric' });
    }

    public ToString(): string {
        return this.displayValue == null ? null : this.displayValue.toString();
    }

    public FromId(id: number): IFuelType {
        return this._dictionary[id];
    }

    public FromValue(value: string): IFuelType {
        var match = this._dictionary.getValues().filter(d => d.value == value);

        if (match.length > 0) {
            return this._dictionary[match[0].id];
        } else {
            return undefined;
        }
    }

    public GetAll(): IFuelType[] {
        return this._dictionary.getValues().sort(this.sort_by('sortOrder', false, null, this.sort_by('displayValue', false, null, null)));
    }

    public GetActive(): IFuelType[] {
        return this.GetAll().filter(d => d.active);
    }

    public Sort(primaryField, secondaryField, reverse): IFuelType[] {
        return this.GetAll().sort(this.sort_by(primaryField, reverse, null, secondaryField != null ? this.sort_by(secondaryField, reverse, null, null) : null));
    }

    private sort_by = (path, reverse, primer, then) => {
        var get = (obj, path) => {
                if (path) {
                    path = path.split('.');

                    for (var i = 0, len = path.length - 1; i < len; i++) {
                        obj = obj[path[i]];
                    }

                    return obj[path[len]];
                }
                return obj;
            },
            prime = (obj) => primer ? primer(get(obj, path)) : get(obj, path);

        return (a, b) => {
            var A = prime(a),
                B = prime(b);

            return (
                (A < B) ? -1 :
                    (A > B) ? 1 :
                        (typeof then === 'function') ? then(a, b) : 0
            ) * [1, -1][+!!reverse];
        };
    };
}
